import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";
import type { Village } from "@/types/MassterData/village";

export async function GetVillageList() {
  const { data } = await apiClient.post<ApiResponse<Village[]>>(
    "/api/v1/masterdata/get_village_list",
  );

  if (!data.status) {
    throw new Error(data.message ?? "Failed to fetch village list");
  }

  return data;
}